'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSvg = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _IconSvgStyled = require('./styles/IconSvgStyled');

var _IconSvgStyled2 = _interopRequireDefault(_IconSvgStyled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var propTypes = {
  /** Turns on/off icon's border */
  border: _propTypes.PropTypes.bool,

  /** Set icon's border width */
  borderWidth: _propTypes.PropTypes.number,

  /** Make icon rounded */
  rounded: _propTypes.PropTypes.bool,

  /** Set icon size */
  size: _propTypes.PropTypes.oneOf(['custom', 'small', 'normal', 'large', 'xlarge']),

  /** Set icon's color scheme */
  colorScheme: _propTypes.PropTypes.oneOf(['light', 'dark', 'default']),

  /** Set exact icon's border color */
  color: _propTypes.PropTypes.string,

  /** Set icon's background color */
  backgroundColor: _propTypes.PropTypes.string,

  /** Set icon's flipping plane */
  flip: _propTypes.PropTypes.oneOf(['none', 'horizontal', 'vertical']),

  /** Rotate icon by some degree */
  rotate: _propTypes.PropTypes.number
};
var defaultProps = {
  border: false,
  borderWidth: 0,
  rounded: false,
  size: 'normal',
  colorScheme: 'default',
  color: '',
  backgroundColor: '',
  flip: 'none',
  rotate: 0
};

var ICON_DEFAULT = _react2.default.createElement('svg', {
  viewBox: '0 0 24 24'
}, _react2.default.createElement('path', {
  d: 'M19,5.5c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.3-0.3c-0.1,0-0.1,0-0.2,0h-10C8.4,5,8.4,5,8.3,5c-0.1,0-0.1,0.1-0.2,0.1l-3,3 c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2v10C5,18.8,5.2,19,5.5,19h10c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l3-3 c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2V5.5z M16,16h1.3L16,17.3V16z M18,15h-2V8.7l2-2V15z M9,9h6v6H9V9z M8,8H6.7L8,6.7V8z M9,6 h8.3l-2,2H9V6z M6,9h2v6.5C8,15.8,8.2,16,8.5,16H15v2H6V9z'
}));

var IconSvg = function IconSvg(_ref) {
  var children = _ref.children,
      backgroundColor = _ref.backgroundColor,
      colorScheme = _ref.colorScheme,
      color = _ref.color,
      size = _ref.size,
      border = _ref.border,
      borderWidth = _ref.borderWidth,
      flip = _ref.flip,
      rounded = _ref.rounded,
      rotate = _ref.rotate,
      props = _objectWithoutProperties(_ref, ['children', 'backgroundColor', 'colorScheme', 'color', 'size', 'border', 'borderWidth', 'flip', 'rounded', 'rotate']);

  return _react2.default.createElement(_IconSvgStyled2.default, _extends({
    backgroundColor: backgroundColor,
    customColor: color,
    colorScheme: colorScheme,
    flip: flip,
    sizeKey: size,
    rotate: rotate,
    border: border,
    borderWidth: borderWidth,
    rounded: rounded
  }, props), children || ICON_DEFAULT);
};

exports.IconSvg = IconSvg;
IconSvg.propTypes = propTypes;
IconSvg.defaultProps = defaultProps;
IconSvg.displayName = 'IconSvg';